import { createConfig } from '@privy-io/wagmi';
import { WagmiConfigParams } from '@vertex-protocol/react-client';
import { useMemo } from 'react';
import { Chain, http } from 'viem';
import { Config } from 'wagmi';

export function getPrivyWagmiConfig({
  supportedChains,
  connectors,
}: WagmiConfigParams): Config {
  return createConfig({
    chains: supportedChains as unknown as readonly [Chain, ...Chain[]],
    connectors,
    transports: Object.fromEntries(
      supportedChains.map((chain) => [chain.id, http(getChainRpcUrl(chain))]),
    ),
  });
}

export function usePrivyWagmiConfig(params: WagmiConfigParams) {
  return useMemo(() => getPrivyWagmiConfig(params), [params]);
}

function getChainRpcUrl(chain: Chain): string | undefined {
  return chain.rpcUrls.default.http[0] ?? chain.rpcUrls.public?.http[0];
}
